var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:{working: _vm.working, shaking: _vm.shaking, highlighting: _vm.highlighting},attrs:{"disabled":_vm.disabled},on:{"click":_vm.onClick}},[(_vm.working)?_c('span',{staticClass:"spinner"}):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }